var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94607 11.1841C8.90691 11.9657 7.6147 12.4289 6.2143 12.4289C2.78224 12.4289 0 9.64663 0 6.21447C0 2.78231 2.78224 0 6.2143 0C9.64636 0 12.4286 2.78231 12.4286 6.21447C12.4286 7.61507 11.9653 8.90745 11.1835 9.9467C11.2806 9.99153 11.3715 10.0539 11.4515 10.1339L15.7269 14.4088C16.091 14.7729 16.091 15.3631 15.7269 15.7271C15.3629 16.091 14.7728 16.091 14.4088 15.7271L10.1334 11.4522C10.0533 11.3721 9.99091 11.2812 9.94607 11.1841ZM11.1857 6.21448C11.1857 8.9602 8.95995 11.1861 6.2143 11.1861C3.46865 11.1861 1.24286 8.9602 1.24286 6.21448C1.24286 3.46875 3.46865 1.2429 6.2143 1.2429C8.95995 1.2429 11.1857 3.46875 11.1857 6.21448Z",
    fill: "#B0BBBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.72f8e8b6508d74e92865df2b6d95af77.svg";
export { ForwardRef as ReactComponent };